import { Clock, Eye, Sparkles, Users } from 'lucide-react';
import { useTranslation } from 'next-i18next';
import { useEffect, useMemo, useState } from 'react';
import LoginIcon from '@/icons/unfollow/login.svg';
import DataIcon from '@/icons/unfollow/data.svg';
import ExportIcon from '@/icons/unfollow/export.svg';
import RightIcon from '@/icons/unfollow/right.svg';

import styles from './index.module.less';

interface UnfollowBannerProps {}

const UnfollowBanner: React.FC<UnfollowBannerProps> = () => {
  const { t } = useTranslation('common');

  const [currentWord, setCurrentWord] = useState(0);

  const words = useMemo(() => {
    return [
      { text: t('Unfollowed You'), color: '#10B981' },
      { text: t('Not Following You Back'), color: '#F97316' },
      { text: t('Follows You Too'), color: '#7C3AED' },
    ];
  }, []);

  const features = useMemo(() => {
    return [
      { icon: <LoginIcon className={styles.icon} />, title: t('No IG Login Needed') },
      { icon: <DataIcon className={styles.icon} />, title: t('Anonymous & Legal') },
      { icon: <ExportIcon className={styles.icon} />, title: t('Exportable results table') },
      { icon: <RightIcon className={styles.icon} />, title: t('Reliable & Accurate Data') },
    ];
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWord((prev) => (prev - 1 + words.length) % words.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.container}>
      <h1 className="hidden">{t('The Best Instagram Unfollowers Tracker See who')}</h1>

      <div className={styles.header}>
        <div className={styles.title}>
          <div className="mb-2">
            {t('The Best Instagram Unfollowers Tracker')}{' '}
            <span className={styles['gradient-text']}>{t('See who')}</span>
          </div>
          <div className={styles.subtitleContainer}>
            <span className={styles['gradient-text-pc']}>{t('See who')}</span>
            <div style={{ overflow: 'hidden', flex: '1' }}>
              <span className={styles['word-cycle']}>
                {words.map((word, index) => (
                  <span
                    key={word.text}
                    style={{
                      display: 'inline-block',
                      opacity: currentWord === index ? 1 : 0,
                      transition: 'opacity 0.2s',
                      position: 'absolute',
                      whiteSpace: 'nowrap',
                      top: '0',
                      color: word.color,
                    }}
                  >
                    {word.text}
                  </span>
                ))}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.features}>
        {features.map((feature) => (
          <div className={styles.feature} key={feature.title}>
            {feature.icon}
            <p>{feature.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UnfollowBanner;
